<template>
    <div class="dlab-user-search-filter-wrap d-flex justify-content-between align-center flex-wrap mb-30px">
        <h1 class="w-100 mb-3 fs-22" v-if="title">{{title}}</h1>
        <div class="dlab-user-search-bar">
            <el-input
                size="large"
                v-model="userName"
                :placeholder="inputPlaceholder"
                clearable
            />
        </div>

        <el-select v-model="searchUserFilter" clearable class="dlab-user-search-selectbox" placeholder="Select" size="large">
            <el-option
            v-for="item in selectOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            />
        </el-select>
    </div>
</template>


<script>

export default {
    name: 'SearchUserFilter',
    props: ['title', 'inputPlaceholder', 'selectOption'],
    components: {
    },
    data() {
        return {
            userName: '',
            searchUserFilter: '',
        }
    }
}
</script>